module.exports = __webpack_public_path__ + "img/9.49d67167.jpg";